import { FACETS } from '../actions/types';
import createReducer from './createReducer';

/**
 * todo
 */

const reduceFacets = {
  [FACETS.REQUEST_TYPES_ALL_SUCCEEDED]: (prevState, payload) => Object.assign({}, { allTypes: payload.data, allSubTypes: prevState.allSubTypes }),
  [FACETS.REQUEST_SUBTYPES_ALL_SUCCEEDED]: (prevState, payload) => Object.assign({}, { allTypes: prevState.allTypes, allSubTypes: payload.data }),
};


const initialState = { allTypes: null, allSubTypes: null };
export default createReducer(initialState, reduceFacets);
